var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 17,
    viewBox: "0 0 38 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3189 10.483L15.6562 16.521L21.6717 16.5235L23.3343 10.4858L27.383 10.4873C28.5846 10.488 29.5395 9.79794 29.838 8.71388L30.559 6.09526L18.5285 6.08997L17.3189 10.483Z",
    fill: "#ED0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2624 0.0030094L3.22904 -0.000871634C2.02786 -0.00157717 1.07256 0.688794 0.774115 1.77286L-0.00585938 4.6056L10.9939 4.61019L7.71557 16.5169L13.731 16.5193L18.2779 0.00583135L12.2624 0.0030094Z",
    fill: "#224BAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2031 0.00697021L18.9346 4.61415L33.983 4.62085C35.1846 4.6212 36.1395 3.93118 36.4383 2.84712L37.2183 0.0143784L20.2031 0.00697021Z",
    fill: "#224BAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoading);
export default __webpack_public_path__ + "static/media/logo-loading.11c464957a0a71b441afea9f4cf779a8.svg";
export { ForwardRef as ReactComponent };